module Meevo.Plugins.SecurityRolesManager {
  "use strict";

  /**
  * Main Section of SecurityRole 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.SecurityRole> {

    /**
  * Base class override which defines what a DEFAULT model looks like.
  */
    createSectionModelInstance(postAdd:(data:any)=>any): void {
        let instance: Model.SecurityRole = {
        id: Guid.empty.toString(),
        objectState: Meevo.Model.ObjectStateEnum.Active,
        objectCreationType: Meevo.Model.ObjectCreationTypeEnum.User,
        displayName: "",
        description: "",
        securityItems: null
      };

      this.model = instance;
    }
   
  }

}